import { styled } from '@mui/material';

type CourseAcademicFooterBannerContainerProps = {
  isSticky: boolean;
};

export const CourseAcademicFooterBannerContainer = styled('div')<CourseAcademicFooterBannerContainerProps>(
  ({ theme, isSticky }) => ({
    position: isSticky ? 'sticky' : 'relative',
    bottom: isSticky ? 0 : 'auto',
    width: '100%',
    backgroundColor: theme.palette.textOnPrimary.primary,
    color: theme.palette.textOnPrimary.primary,
    height: '160px',
    zIndex: isSticky ? theme.zIndex.tooltip + 100 : 'auto',

    [theme.breakpoints.down('sm')]: {
      height: '80px',
    },
  }),
);
